import { FC } from 'react';

/**
 *
 * TODO: 정산 관리 페이지 구현
 * 보는 user:
 *  - admin: 전체 조회 + 수정/생성/지급확정 (정산을 실제로 집행하는 주체는 항상 admin)
 *  - giftAgent(마리): view만. 수정 불가. 그리고 "마리 경유분"만 보임 (아래 마리 규칙 참고)
 * 1. 쿠폰형 | 배송형 정산 분리
 * 2. 현재는 배송형만 개발 필요
 * 3. 배송형 탭 기준 (giftDelivery)
 * -> 배송완료된 내역 중 정산이 되지 않은 건에 대한 표시 (정산 예정 내역)
 * -> 업체정산 | 상조정산 기능
 * -> 정산 완료된 내역에 대한 표시 (언제 누구에게 정산했는지) (업체 | 상조 구분)
 * -> 결국 우리한테 얼마 남았는지까지 확인 수익금까지
 *
 * 4. 마리 경유(viaMari) 구분 규칙  ★신규
 *  정산 주체(accountEntity)는 두 갈래: 마리(Mari) | 가온(Gaon, 우리). 두 방식이 공존하므로
 *  "마리 통해서 줄 곳"과 "가온이 직접 줄 곳"을 한 화면에서 구분해 보여줘야 함.
 *  (지금은 두 방식뿐이니 그에 맞는 UI/UX. 마리는 외부지만 내부인처럼 대우)
 *
 *  ── accountEntity 는 "누구에게 돈 줄 때"냐에 따라 두 군데에 따로 존재 (의미가 다름) ──
 *   (전자) 상조정산(rebate): bugoBrand.accountConfig.accountEntity (≒ giftAccountConfig.viaMari)
 *          → 상조(bugoBrand)에게 돈 줄 때 마리를 통해서 주는가
 *   (후자) 업체정산(supply): giftItemBrand.settlementInfo.accountEntity
 *          → 업체(giftItemBrand)에게 돈 줄 때 누구(마리/가온)를 통해서 주는가
 *  → 정산예정·정산완료 내역 양쪽 모두 이 두 축으로 "마리 경유 / 가온 직접"을 구분 표시.
 *
 *  ── 도매가 3종을 헷갈리지 말 것 ──
 *   ① 업체 실지급(supply): 언제나 giftItemInfo.priceWhole (실제 계약가, Mari/Gaon 무관)
 *   ② 상조 rebate 차감(FeeRate): 언제나 giftItem.priceWhole — 상조에게 제시하는 표시값.
 *      업체가 Mari여도 동일(마리와 함께 상조를 속여 우리 마진을 남기는 부분). 실제가와의
 *      차액(giftItem − giftItemInfo)이 우리 마진.
 *   ③ supply "도매가" 컬럼 표시(displayWholePrice): 마리에게 업체 도매가 보여줄 때만 분기
 *      · accountEntity === Mari → giftItemInfo.priceWhole (마리 직접정산 → 속일 이유 없어 실제가)
 *      · accountEntity === Gaon → giftItem.priceWhole
 *      → ②(rebate)와 무관. 어디까지나 supply 표시용.
 *
 *  ── giftAgent(마리) 접근 시: view 전용 + "마리가 관여하는 건"만 노출 ──
 *   한 giftDelivery 에는 마리 축이 둘(상조 rebate / 업체 supply) 있고, 둘 중
 *   하나라도 viaMari 면 마리가 관여하므로 노출한다:
 *     · 상조(rebate) viaMari  → 노출
 *     · 업체(supply) viaMari   → 노출
 *     · 상조도 업체도 viaMari 아님(둘 다 Gaon) → 아예 표시 안 함
 *   supply "도매가" 컬럼은 위 ③ displayWholePrice 규칙 그대로(업체 Mari→giftItemInfo,
 *   Gaon→giftItem). rebate 차감은 ② 대로 항상 giftItem.priceWhole.
 */

/**
 * api 설명
 * 배송형 기준 giftDelivery 조회
 * 상조정산은 gift-rebate-settlement, 업체정산은 gift-supply-settlement
 * accountEntity enum: Mari | Gaon | NotDecided (account-config)
 */

export const GiftSettlementPage: FC = function GiftSettlementPage() {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {/* 헤더 */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">정산 관리</h1>
        <p className="mt-1 text-sm text-gray-500">공급사별 정산 내역 조회 및 관리</p>
      </div>
    </div>
  );
};
